import React, { useState } from 'react';
import { makeStyles, Container } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Headroom from 'react-headroom';
import LogoDesktop from '../../assets/images/ocbc-logo.png';
import LogoMobile from '../../assets/images/logo-mobile.png';
{
  /* <Header
      namePage='OCBC Equities trading'
      backLink={{name:'Back to OCBC.com', href: '#'}}
      listBackLink={[
        {name:'Back to OCBC.com', href: '#'},
        {name:'Back to OCBC.com', href: '#'}
        {name:'Back to OCBC.com', href: '#'}
      ]}
      ></Header> */
}

const useStyles = makeStyles(
  (theme) => ({
    root: {},
    headerComponent: {
      width: '100%',
      top: '0',
      left: '0',
      zIndex: '999',
      backgroundColor: theme.palette.$lightWhite,
      boxShadow: '0 2px 15px 8px rgba(0, 0, 0, 0.02)',
      transition: 'all 0.25s ease',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '0',
        left: '0',
        height: '100%',
        width: '8px',
        backgroundImage: `linear-gradient(to top, ${theme.palette.$lipstick}, ${theme.palette.$orangeyRed})`,
        zIndex: '1001',
      },
      '& .header-component-justify': {
        padding: '30px 0',
        height: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'flex',
      },
      '& .header-component-left': {
        height: '58px',
        display: 'flex',
        alignItems: 'center',
        '& .logo-pc': {
          width: '180px',
          '& img': {
            width: '100%',
          },
        },
        '& .logo-mobile': {
          display: 'none',
        },
        '& .height-line': {
          width: '1px',
          height: '100%',
          backgroundColor: theme.palette.$veryLightPink,
          margin: '0 30px',
        },
        '& span': {
          fontSize: theme.typography.$fzH6,
        },
      },
      '& .header-component-right': {
        height: '58px',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.$battleshipGrey,
        fontSize: theme.typography.$fzH6,
        '& .header-icon-mobile': {
          display: 'none',
        },
      },
      '& .header-mobile-active': {
        display: 'none',
      },
      '& .header-mobile-hide': {
        height: 'auto',
        display: 'none',
        transform: 'translateY(-1000%)',
      },

      '@media (max-width: 992px)': {
        height: 'auto',
        display: 'block',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '5px',
          backgroundImage: `linear-gradient(to top, ${theme.palette.$lipstick}, ${theme.palette.$orangeyRed})`,
        },
        '& .header-component-justify': {
          padding: '20px',
          display: 'flex',
          height: '65px',
          boxSizing: 'border-box',
        },
        '& .header-component-left': {
          textAlign: 'left',
          height: 'auto',
          '& .logo-pc': {
            display: 'none',
          },
          '& .logo-mobile': {
            display: 'block !important',
            '& img': {
              width: 'auto',
              height: '25px',
              marginRight: '10px',
            },
          },
          '& .height-line': {
            display: 'none',
          },
          '& span': {
            fontSize: theme.typography.$fzH6,
            // display: 'none',
            paddingLeft: '10px',
            height: '100%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            borderLeft: '1px solid #d9d9d9',
          },
        },
        '& .header-component-right': {
          height: 'auto',
          textAlign: 'right',
          '& .header-link-pc': {
            display: 'none',
          },
          '& .header-icon-mobile': {
            display: 'block !important',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '& span': {
              display: 'block !important',
              width: '15px',
              height: '2px',
              margin: '4px 0',
              backgroundColor: '#3b444f',
              transition: 'all 0.3s ease',
            },
          },
          '& .active': {
            '& span:nth-child(1)': {
              transform: 'translateY(3px) rotate(45deg)',
            },
            '& span:nth-child(2)': {
              transform: 'translateY(-3px) rotate(-45deg)',
            },
          },
        },
        '& .header-mobile-active': {
          height: '100vh',
          padding: '0 30px',
          display: 'block',
          '& .header-mobile-border': {
            borderTop: `0.5px solid ${theme.palette.$veryLightPink}`,
          },
          '& .header-mobile-list': {
            padding: '0px 15px 20px',
            textAlign: 'left',
          },
          '& a': {
            width: '100%',
            marginTop: '20px',
          },
        },
        '& .header-mobile-hide': {
          height: '0px',
          transform: 'translate(-300%)',
        },
      },
    },
    container: {
      padding: '0',
      maxWidth: '1440px',
      '@media only screen and (max-width: 1546px) and (min-width: 768px)': {
        padding: '0 40px',
      },
    },
  }),
  'header-component',
);

const Header = ({ namePage, backLink }) => {
  const [] = useState(false);
  const classes = useStyles();
  return (
    <Headroom
      style={{
        transition: 'all .5s ease-in-out',
      }}
    >
      <div className={clsx(classes.headerComponent)}>
        <Container className={classes.container}>
          <div className="header-component-justify">
            <div className="header-component-left">
              <div className="logo-pc">
                <a href={backLink.href}>
                  <img
                    src={LogoDesktop}
                    alt="#"
                  />
                </a>
              </div>
              <div className="logo-mobile">
                <a href={backLink.href}>
                  <img src={LogoMobile} alt="#" />
                </a>
              </div>
              <div className="height-line" />
              <span>{namePage}</span>
            </div>
          </div>
        </Container>
      </div>
    </Headroom>
  );
};

Header.defaultProps = {
  namePage: '',
  backLink: {},
  listBackLink: [],
  target: '',
};

Header.propTypes = {
  namePage: PropTypes.string,
  backLink: PropTypes.object,
  listBackLink: PropTypes.array,
  target: PropTypes.string,
};

export default Header;
